import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-cashout-confirmation',
  templateUrl: './cashout-confirmation.component.html',
  styleUrl: '../add-cashout.component.scss',
})
export class CashoutConfirmationComponent {
  @Input() details: Array<{ label: string; value: string }> = [];
  @Input() addingTransaction = false;

  @Output() back = new EventEmitter<void>();
  @Output() confirm = new EventEmitter<void>();
}

